module.exports = __webpack_public_path__ + "static/media/user-guide-9.74b07b55.png";